import React from "react"
import { Folder, ChevronDown } from "lucide-react"
import ReportCard from "./ReportCard"
import { formatWeekLabel } from "../../data/reportsData"

const WeekAccordionItem = ({ week, reports, expanded, onToggle }) => {
  return (
    <div className="week-accordion-item">
      <button
        type="button"
        className="week-accordion-header"
        onClick={onToggle}
        aria-expanded={expanded}
      >
        <span className="week-accordion-label">
          <Folder size={16} />
          {formatWeekLabel(week.weekOf)}
        </span>

        <span className="week-accordion-meta">
          <span className="week-accordion-count">{reports.length} reports</span>
          <ChevronDown
            size={16}
            className={`week-accordion-chevron ${expanded ? "open" : ""}`}
          />
        </span>
      </button>

      {expanded && (
        <div className="week-accordion-body">
          <div className="reports-grid">
            {reports.map((report) => (
              <ReportCard key={report.id} report={report} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default WeekAccordionItem
